(function () {
  var BAG_BELT_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0947/5791/2922/files/size-guide-tasche-guertel.png?v=1785074037';

  function isBagOrBeltProduct() {
    var titleEl = document.querySelector('.product__title h1, .product__title');
    var title = titleEl ? titleEl.textContent : '';
    return /tasche|gürtel/i.test(title);
  }

  function bagOrBeltImageHtml() {
    return '<div style="text-align: left;"><img src="' + BAG_BELT_IMAGE_URL + '" alt="Größentabelle Tasche und Gürtel"></div>';
  }

  function buildSizeGuideModal() {
    const overlay = document.createElement('div');
    overlay.className = 'onhow-size-guide-overlay';
    overlay.hidden = true;

    const modal = document.createElement('div');
    modal.className = 'onhow-size-guide-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<button type="button" class="onhow-size-guide-modal__close" aria-label="Schließen"></button>' +
      '<div class="onhow-size-guide-modal__body"><p>L&auml;dt&hellip;</p></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    const body = modal.querySelector('.onhow-size-guide-modal__body');
    let cachedImageHtml = null;
    let cachedRestHtml = null;

    function close() {
      overlay.hidden = true;
      modal.hidden = true;
    }

    overlay.addEventListener('click', close);
    modal.querySelector('.onhow-size-guide-modal__close').addEventListener('click', close);

    async function open() {
      overlay.hidden = false;
      modal.hidden = false;

      if (cachedImageHtml === null) {
        try {
          const res = await fetch('/pages/kopie-von-grossentabelle');
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const rte = doc.querySelector('.rte');
          if (rte) {
            const image = rte.querySelector('img');
            cachedImageHtml = image && image.parentElement ? image.parentElement.outerHTML : '';
            if (image && image.parentElement) image.parentElement.remove();

            const pointerParagraph = Array.from(rte.querySelectorAll('p')).find((p) =>
              p.textContent.includes('Maßangaben')
            );
            if (pointerParagraph) pointerParagraph.remove();

            cachedRestHtml = rte.innerHTML;
          } else {
            cachedImageHtml = '';
            cachedRestHtml = '<p>Die Gr&ouml;&szlig;entabelle konnte nicht geladen werden.</p>';
          }
        } catch (error) {
          cachedImageHtml = '';
          cachedRestHtml = '<p>Die Gr&ouml;&szlig;entabelle konnte nicht geladen werden.</p>';
        }
      }

      let measurementsHtml = '';
      const measurementsContent = document.querySelector('.product__accordion .accordion__content');
      if (measurementsContent && measurementsContent.textContent.trim()) {
        measurementsHtml =
          '<div class="onhow-size-guide-modal__measurements">' +
          '<p class="onhow-size-guide-modal__measurements-title">Ma&szlig;e f&uuml;r diesen Artikel</p>' +
          measurementsContent.innerHTML +
          '</div>';
      }

      const mainImageHtml = isBagOrBeltProduct() ? bagOrBeltImageHtml() : cachedImageHtml;

      body.innerHTML = mainImageHtml + measurementsHtml + cachedRestHtml;
    }

    return { open, close };
  }

  function buildQuicklinksRow() {
    const productForm = document.querySelector('main product-form');
    if (!productForm || !productForm.parentElement) return;

    const row = document.createElement('div');
    row.className = 'product-quicklinks';
    let inserted = false;

    function ensureInserted() {
      if (inserted) return;
      inserted = true;
      productForm.parentElement.insertBefore(row, productForm);
    }

    const measurementsAccordion = document.querySelector('.product__accordion');
    if (measurementsAccordion) {
      const link = document.createElement('button');
      link.type = 'button';
      link.className = 'product-quicklinks__measurements';
      link.textContent = 'Zu den Maßen';
      link.addEventListener('click', () => {
        const details = measurementsAccordion.querySelector('details');
        if (details) details.open = true;
        measurementsAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      row.appendChild(link);
      ensureInserted();
    }

    const sizeGuideModal = buildSizeGuideModal();

    function attachSizeToggle(toggle) {
      row.appendChild(toggle);
      toggle.classList.add('onhow-app-toggle-hidden');

      const replacement = document.createElement('button');
      replacement.type = 'button';
      replacement.className = 'product-quicklinks__measurements';
      replacement.textContent = 'Passt mir der Artikel?';
      replacement.addEventListener('click', () => sizeGuideModal.open());

      toggle.insertAdjacentElement('afterend', replacement);
      ensureInserted();
    }

    const existingToggle = document.querySelector('[class*="size-toggle-template"]');
    if (existingToggle) {
      attachSizeToggle(existingToggle);
    } else {
      const observer = new MutationObserver(() => {
        const toggle = document.querySelector('[class*="size-toggle-template"]');
        if (toggle) {
          attachSizeToggle(toggle);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    }
  }

  function buildAuthenticityBar() {
    const gallery = document.querySelector('main media-gallery');
    if (!gallery) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'authenticity-bar-wrapper';

    const panel = document.createElement('div');
    panel.className = 'authenticity-bar__panel';
    panel.hidden = true;
    panel.innerHTML =
      '<button type="button" class="authenticity-bar__close" aria-label="Schließen">&times;</button>' +
      '<p>Jedes Teil wird vor dem Versand von uns auf Echtheit gepr&uuml;ft. Durch unsere Erfahrung mit Vintage-Markenware erkennen wir F&auml;lschungen zuverl&auml;ssig. So kannst du sicher sein, dass du bei uns immer ein zu 100&nbsp;% originales Produkt bekommst.</p>';

    const bar = document.createElement('div');
    bar.className = 'authenticity-bar';
    bar.innerHTML =
      '<span class="authenticity-bar__title">Echtheits-Garantie</span>' +
      '<button type="button" class="authenticity-bar__info" aria-expanded="false">' +
      'Mehr Infos' +
      '<span class="authenticity-bar__info-icon">i</span>' +
      '</button>';

    wrapper.appendChild(panel);
    wrapper.appendChild(bar);

    const infoButton = bar.querySelector('.authenticity-bar__info');
    const closeButton = panel.querySelector('.authenticity-bar__close');

    function toggle(show) {
      panel.hidden = !show;
      infoButton.setAttribute('aria-expanded', String(show));
    }

    infoButton.addEventListener('click', () => toggle(panel.hidden));
    closeButton.addEventListener('click', () => toggle(false));

    gallery.appendChild(wrapper);
  }

  function updateTaxCaption() {
    const taxCaption = document.querySelector('main .product__tax');
    if (!taxCaption) return;
    taxCaption.textContent = 'inkl. MwSt. zzgl. Versandkosten';
  }

  function buildTrustBadges() {
    const firstAccordion = document.querySelector('.product__accordion');
    if (!firstAccordion || !firstAccordion.parentElement) return;

    const wrap = document.createElement('div');
    wrap.className = 'product-trust-badges';
    wrap.innerHTML =
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__truckIcon || '') + '</span>' +
      '<span>Kostenloser Versand ab 75 €</span>' +
      '</div>' +
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__returnIcon || '') + '</span>' +
      '<span>14 Tage Rückgaberecht</span>' +
      '</div>';

    firstAccordion.parentElement.insertBefore(wrap, firstAccordion);
  }

  function init() {
    buildQuicklinksRow();
    buildAuthenticityBar();
    updateTaxCaption();
    buildTrustBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
